"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SortArrow_styles_1 = require("./SortArrow.styles");
const ArrowDown2_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown2"));
const ArrowUp2_1 = __importDefault(require("@kyruus/react-ikons/ArrowUp2"));
const constants_1 = require("../constants");
/** Component that renders an arrow icon
 * indicating the direction of the sort. */
const SortArrow = ({ sortOrder }) => (react_1.default.createElement(SortArrow_styles_1.StyledSortArrow, null, sortOrder === constants_1.SortOrder.DESC ? react_1.default.createElement(ArrowDown2_1.default, null) : react_1.default.createElement(ArrowUp2_1.default, null)));
exports.default = SortArrow;
//# sourceMappingURL=SortArrow.js.map